import { useUserStore } from '@/shared/stores/user'
import { minutesToHours, secondsToMinutes } from 'date-fns'
import { format, formatInTimeZone } from 'date-fns-tz'

interface FormatTimestampOptionalArgs {
  formatString?: string
  forceLocalTimezone?: boolean
}

export const formatTimestamp = (
  timestamp: number,
  optionalArgs?: FormatTimestampOptionalArgs
) => {
  if (!timestamp) return null

  const userStore = useUserStore()

  const dateFormat = userStore.user?.dateFormat
    ? userStore.user.dateFormat
    : 'M/d/yyyy'

  const formatPattern = optionalArgs?.formatString || `${dateFormat} h:mm aaa`

  const timezone = optionalArgs?.forceLocalTimezone
    ? null
    : userStore.user?.timezone

  if (timezone) {
    return formatInTimeZone(timestamp, timezone.name, formatPattern)
  } else {
    return format(new Date(timestamp), formatPattern)
  }
}

export const formatTimeLeft = (timeLeft: number) => {
  if (timeLeft < 60) {
    return `${timeLeft} sec left`
  }

  const minutes = secondsToMinutes(timeLeft)

  if (minutes >= 60) {
    const remainingMinutes = minutes % 60
    const hours = minutesToHours(minutes)
    const hourAbbr = hours > 1 ? 'hrs' : 'hr'

    return `${hours} ${hourAbbr} ${remainingMinutes} min left`
  }

  return `${minutes} min left`
}

export const isDateString = (firstDate: Date | number | string) => ({
  greaterOrEqualTo(secondDate: Date | number | string) {
    const date1 = new Date(new Date(firstDate).toLocaleDateString())
    const date2 = new Date(new Date(secondDate).toLocaleDateString())

    return date1 >= date2
  },
  greaterThan(secondDate: Date | number | string) {
    const date1 = new Date(new Date(firstDate).toLocaleDateString())
    const date2 = new Date(new Date(secondDate).toLocaleDateString())

    return date1 > date2
  },
  equalTo(secondDate: Date | number | string) {
    const date1 = new Date(new Date(firstDate).toLocaleDateString())
    const date2 = new Date(new Date(secondDate).toLocaleDateString())

    return date1 === date2
  },
})

export const isTimeString = (firstDate: Date | number | string) => ({
  greaterOrEqualTo(secondDate: Date | number | string) {
    const date1 = new Date(`0 ${new Date(firstDate).toLocaleTimeString()}`)
    const date2 = new Date(`0 ${new Date(secondDate).toLocaleTimeString()}`)

    return date1 >= date2
  },
})
